var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperatureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 25,
    viewBox: "0 0 11 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46785 3.26058V8.5623H3.79932V3.23407C3.80815 2.50951 4.40018 1.91748 5.13358 1.91748C5.86699 1.91748 6.45901 2.50067 6.46785 3.23407V3.26058C6.46785 3.26058 6.46785 3.26058 6.46785 3.26058ZM6.14975 8.46511V3.35778V3.24291C6.14091 2.69507 5.68143 2.24442 5.13358 2.24442C4.58574 2.24442 4.12626 2.69507 4.11742 3.24291V3.34011V8.47394H6.14975V8.46511Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13383 24.4147C2.30625 24.4147 0 22.1084 0 19.2809C0 17.655 0.786422 16.1175 2.07651 15.1544V3.19014C2.07651 1.50242 3.44612 0.132812 5.13383 0.132812C6.82155 0.132812 8.19116 1.50242 8.19116 3.19014V15.1544C9.48124 16.1175 10.2677 17.655 10.2677 19.2809C10.2677 22.1173 7.97025 24.4147 5.13383 24.4147ZM5.13383 23.5576C7.4931 23.5576 9.41055 21.6401 9.41055 19.2809C9.41055 17.761 8.6153 16.3826 7.33405 15.6138V3.19014C7.33405 1.97958 6.34439 0.989924 5.13383 0.989924C3.92327 0.989924 2.93362 1.97958 2.93362 3.19014V15.6138C1.65237 16.3826 0.857112 17.761 0.857112 19.2809C0.865948 21.6401 2.7834 23.5576 5.13383 23.5576Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27795 13.7051H7.33398V14.2971H9.27795V13.7051Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27792 11.9907H8.43848V12.5827H9.27792V11.9907Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27795 10.2764H7.33398V10.8684H9.27795V10.2764Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27792 8.55371H8.43848V9.14574H9.27792V8.55371Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27795 6.83936H7.33398V7.43138H9.27795V6.83936Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27792 5.125H8.43848V5.71703H9.27792V5.125Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27795 3.41064H7.33398V4.00267H9.27795V3.41064Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5442 19.2809C8.5442 21.163 7.01554 22.6916 5.13343 22.6916C3.25132 22.6916 1.72266 21.163 1.72266 19.2809C1.72266 17.8671 2.57977 16.6653 3.79916 16.144V8.55371H6.4677V16.144C7.68709 16.6653 8.5442 17.8759 8.5442 19.2809ZM3.34852 17.9024C2.91554 17.9024 2.57093 18.4149 2.57093 19.0334C2.57093 19.6608 2.91554 20.1645 3.34852 20.1645C3.78149 20.1645 4.1261 19.652 4.1261 19.0334C4.1261 18.4061 3.78149 17.9024 3.34852 17.9024ZM4.28515 16.0556L4.62093 15.985V8.55371H4.28515V16.0556Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62093 3.60534C4.6121 3.51698 4.54141 3.44629 4.45304 3.44629C4.36468 3.44629 4.29399 3.51698 4.28516 3.60534V8.55361H4.62093V3.60534Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/TemperatureIcon.3a64c6653afcbfca6e115d9c6c79d603.svg";
export { ForwardRef as ReactComponent };